module.exports = __webpack_public_path__ + "img/sygnet.09e175b6.jpg";